import {
  BULK_UPDATE_WORKFLOW_STATUS_MODAL_CLOSE,
  BULK_UPDATE_WORKFLOW_STATUS_MODAL_OPEN,
} from './actions';

const initialState = {
  isOpen: false,
  quoteItemIds: [],
  componentIds: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case BULK_UPDATE_WORKFLOW_STATUS_MODAL_OPEN:
      return {
        ...state,
        isOpen: true,
        quoteItemIds: payload.quoteItemIds,
        componentIds: payload.componentIds,
      };
    case BULK_UPDATE_WORKFLOW_STATUS_MODAL_CLOSE:
      return {
        ...state,
        isOpen: false,
        quoteItemIds: [],
        componentIds: [],
      };
    default:
      return state;
  }
};

const getScope = (state) =>
  state.modules.quotes.quoteItemNav.bulkUpdateWorkflowStatusModal;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getQuoteItemIds = (state) => getScope(state).quoteItemIds;

export const getComponentIds = (state) => getScope(state).componentIds;

export default reducer;
